import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";

export const blobErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse): Observable<HttpEvent<any>> => {
      if (error.error instanceof Blob && error.error.type.startsWith("application/json")) {
        // Convert Blob → text → JSON
        return new Observable<HttpEvent<any>>((subscriber) => {
          error.error.text().then((text: string) => {
            try {
              const json = JSON.parse(text);

              subscriber.error(
                new HttpErrorResponse({
                  error: json,
                  status: error.status,
                  statusText: error.statusText,
                  url: error.url ?? undefined,
                  headers: error.headers,
                })
              );
            } catch (error) {
              subscriber.error(error); // fallback if parsing fails
            }
          });
        });
      }

      // Fallback: not a Blob error
      return throwError(() => error);
    })
  );
};
